<template>
  <div>
    <!-- 个人中心头部信息 -->
    <div class="mytitle">
       <img :src="washerPhoto" alt="">
       <div class="cfff ml30 cfff mt10">
         <div class="font32">{{washerName}}</div>
         <div class="mt10 font28">{{washerPhoneNumber}}</div>
       </div>
       <div class="withdrawal mt20" @click="signOut()">重新登录</div>
    </div>
    <!-- 个人中心头部信息 -->
    <!-- 接单量及收入 -->
    <div class="business">
      <div class="businessli">
        <div class="textcenter font28">今日接单</div>
        <div class="textcenter font40 c333">{{ordersToday}}</div>
        <div class="fgx"></div>
      </div>

      <div class="businessli">
        <div class="textcenter font28">今日收入</div>
        <div class="textcenter font40 c333">{{incomeToday}}</div>
        <div class="fgx"></div>
      </div>
    </div>
    <!-- 接单量及收入 -->

    <!-- 功能模块 -->
    <ul class="functionlist">
      <li class="funli" @click="openNot()">
        <img src="../../static/image/pingjia.png" alt="">
        <div class="textcenter c000 mt10" >评价</div>
      </li>
      <li class="funli" @click="openNot()">
        <img src="../../static/image/kefu.png" alt="">
        <div class="textcenter c000 mt10" >客服</div>
      </li>
      <li class="funli" @click="openNot()">
        <img src="../../static/image/guzhang.png" alt="">
        <div class="textcenter c000 mt10">故障维修</div>
      </li>
      <li class="funli" @click="navToAnalysis()">
        <img src="https://oss.metalcar.cn/setting/shouru.png" alt="">
        <div class="textcenter c000 mt10">收入分析</div>
      </li>
      <li class="funli" @click="navToSite()">
        <img src="https://oss.metalcar.cn/setting/wangdian.png" alt="">
        <div class="textcenter c000 mt10">站点切换</div>
      </li>
      <li class="funli" @click="verificationCancel()">
        <img src="https://oss.metalcar.cn/setting/verification.png" alt="">
        <div class="textcenter c000 mt10">团购核销</div>
      </li>
    </ul>
    <!-- 功能模块end -->
    <Tabbar></Tabbar>
  </div>
</template>

<script>
import Tabbar from '../components/tabbar.vue'
import { Toast } from 'vant'
export default{
  name: 'my', // 个人中心
  components: {
    'Tabbar': Tabbar
  },
  data () {
    return {
      incomeToday: '',
      ordersToday: '',
      washerName: '',
      washerPhoneNumber: '',
      washerPhoto: ''
    }
  },
  created () {
    this.getIndexInfo()
  },
  mounted () {
  },

  methods: {
    // 请求数据
    getIndexInfo () {
      var that = this
      this.$api.HZrequest('/we-chat/gzh/washer/info/get', 'GET', null).then((res) => {
        res = res.data
        that.incomeToday = res.incomeToday
        that.ordersToday = res.ordersToday
        that.washerName = res.name
        that.washerPhoneNumber = res.phoneNumber
        that.washerPhoto = res.headImgUrl
      })
    },
    openNot () {
      Toast('该功能待开放中')
    },
    navToAnalysis () {
      this.$router.push({
        path: '/analysis'
      })
    },
    navToSite () {
      this.$router.push({
        path: '/mySite'
      })
    },
    verificationCancel () {
      this.$router.push({
        path: '/verification'
      })
    },
    signOut(){
      localStorage.removeItem("token");
       this.$api.HZrequest("/we-chat/gzh/loginUrl", "GET", null, null).then(res => {
        location.href = res;
        // location.href = 'http://activate.navicat.com';
      });
    }
  }
}
</script>

<style>
  @import url("../../static/css/my.css");
</style>



// WEBPACK FOOTER //
// src/view/my.vue